/**
 * Decodifica entidades HTML en un texto (ej. &EACUTE; -> É, &eacute; -> é).
 * Soporta decodificación tanto nativa con DOMParser como con reemplazos para entornos sin DOM o fallback.
 */
export function decodeHTMLEntities(text: string | null | undefined): string {
  if (!text) return '';
  
  // Mapa de entidades comunes en mayúsculas y minúsculas
  const htmlEntitiesMap: { [key: string]: string } = {
    '&aacute;': 'á', '&eacute;': 'é', '&iacute;': 'í', '&oacute;': 'ó', '&uacute;': 'ú',
    '&Aacute;': 'Á', '&Eacute;': 'É', '&Iacute;': 'Í', '&Oacute;': 'Ó', '&Uacute;': 'Ú',
    '&ntilde;': 'ñ', '&Ntilde;': 'Ñ',
    '&acute;': '´',
    '&amp;': '&', '&lt;': '<', '&gt;': '>', '&quot;': '"', '&#39;': "'",
    // Versiones en mayúsculas (a veces el backend codifica todo en mayúsculas, ej: &EACUTE;)
    '&AACUTE;': 'Á', '&EACUTE;': 'É', '&IACUTE;': 'Í', '&OACUTE;': 'Ó', '&UACUTE;': 'Ú',
    '&NTILDE;': 'Ñ'
  };

  let decoded = text;
  
  // 1. Intentar decodificación por mapeo directo (rápido, seguro y previene problemas de codificación comunes)
  for (const [entity, char] of Object.entries(htmlEntitiesMap)) {
    const regex = new RegExp(entity, 'g');
    decoded = decoded.replace(regex, char);
  }

  // 2. Intentar usar DOMParser si está disponible para cualquier otra entidad
  if (typeof DOMParser !== 'undefined' && decoded.includes('&')) {
    try {
      const parser = new DOMParser();
      const dom = parser.parseFromString(decoded, 'text/html');
      const docText = dom.body?.textContent || dom.documentElement?.textContent;
      if (docText) {
        decoded = docText;
      }
    } catch (e) {
      console.warn('Error al decodificar entidades HTML con DOMParser:', e);
    }
  }

  return decoded;
}
